import { SVGProps } from 'react';

import { ChartTooltipDot } from '@/components/Charts/components/Tooltip';
import { colorPalette } from '@/theme/colorPalette';

export const CustomActiveBar = ({ x, y, width, height, fill, ry }: SVGProps<SVGElement>) => {
  /** We skip rendering invalid points (points that might have x/y/height/width null)
   * these points should ideally not occur but might occur when extrapolated/interpolated/connectNulls, etc dynamically generated by recharts
   * If they are not handled, they will shoot out of the graph boundaries (due to unexpected behaviour of undefined/coercing to 0)
   * we only want to render bars that have a valid non-null height/width/x/y
   */
  if (!x || !y || !width || !height) return <></>;

  const barMiddleX = (x as number) + (width as number) / 2;
  const barBottom = (y as number) + (height as number);

  return (
    <g>
      <rect x={x} y={y} width={width} height={height} fill={fill} ry={ry} />
      <line x1={barMiddleX} x2={barMiddleX} y1={0} y2={barBottom} stroke={colorPalette.divider} strokeWidth={1} />
      <ChartTooltipDot cx={barMiddleX} cy={y} />
    </g>
  );
};
